// Reusable premium phone mockup that displays a real MockTP screenshot.
// Screenshots are 1080x2400 (9:20) — the frame preserves that ratio so no cropping.
export const PhoneFrame = ({
  src,
  alt,
  widthClass = "w-[260px]",
  float = 0,
  floatDelay = 0,
  className = "",
  glow = false,
}) => (
  <div
    className={className}
    style={float ? { animation: `float ${float}s ease-in-out infinite ${floatDelay}s` } : undefined}
  >
    <div
      className={`relative ${widthClass} rounded-[2.25rem] border-[6px] border-slate-700/70 bg-slate-800 overflow-hidden ${
        glow
          ? "shadow-[0_40px_120px_-20px_rgba(0,220,130,0.25)]"
          : "shadow-[0_40px_100px_-25px_rgba(0,0,0,0.9)]"
      }`}
      style={{ aspectRatio: "1080 / 2400" }}
    >
      <img
        src={src}
        alt={alt}
        loading="lazy"
        className="block h-full w-full object-cover"
      />
      {/* subtle premium light sheen */}
      <div className="pointer-events-none absolute inset-0 bg-gradient-to-br from-white/[0.07] via-transparent to-transparent" />
      <div className="pointer-events-none absolute inset-0 rounded-[1.9rem] shadow-[inset_0_1px_0_0_rgba(255,255,255,0.08)]" />
    </div>
  </div>
);
